import React from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import './style.css';

const ConfirmModal = ({
  okLabel,
  cancelLabel,
  title,
  message,
  show,
  proceed,
  dismiss,
  cancel,
}) => (
  <Dialog
    open={show}
    onClose={dismiss}
    aria-labelledby="confirmation-alert"
    aria-describedby="confirm-selection"
    disableBackdropClick={true}
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={cancel} color="primary">
        {cancelLabel}
      </Button>
      <Button onClick={proceed} color="primary" autoFocus>
        {okLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmModal.defaultProps = {
  proceed: () => undefined,
  cancel: () => undefined,
  dismiss: () => undefined,
  okLabel: 'Okay',
  cancelLabel: 'Cancel',
  show: false,
  enableEscape: true,
};

ConfirmModal.propTypes = {
  proceed: PropTypes.func, // called when ok button is clicked.
  cancel: PropTypes.func, // called when cancel button is clicked.
  dismiss: PropTypes.func, // called when backdrop is clicked or escaped.

  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  show: PropTypes.bool,
  enableEscape: PropTypes.bool,
};

export const confirm = createConfirmation(confirmable(ConfirmModal));



// WEBPACK FOOTER //
// ./src/utils/modals.js